// Hero.js
import React from 'react';
import './Hero.css';
import heroImage from '../assets/pulmao.jpeg';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="hero-content">
            <h1>Transformando a Saúde com Inovação e Tecnologia</h1>
            <p>
              Na <strong>Bientech</strong>, unimos saúde e tecnologia para criar soluções 
              que fazem diferença na vida das pessoas. Desenvolvemos jogos que tornam o tratamento mais divertido
              e aplicativos que auxiliam na avaliação respiratória dos pacientes.
            </p>
            <p>
              Somos representante e suporte técnico de fabricantes chinesas de equipamentos para fisioterapia respiratória, 
              garantindo a qualidade e o suporte necessário para nossos clientes.
            </p>
            <p>
              Nossas soluções integram equipamento, aplicativo e portal web. O ecossistema com <strong>BTOne</strong> e <strong>PulmoScan</strong> 
              (incluindo o módulo <strong>PulmoGame</strong>) é voltado ao profissional e foca na avaliação e treinamento da pressão respiratória 
              (PImáx e PEmáx), com IA gerando insights nos relatórios. Em desenvolvimento, o ecossistema <strong>BTTwo</strong> e <strong>PulmoFlow </strong> 
              segue o mesmo conceito, mas voltado ao paciente, que coleta o pico de fluxo, responde aos questionários ACT/CAT e envia amostras aos médicos para análise no portal.
            </p>
            <p>
              Nossa missão é trazer inovação para a área da saúde, combinando tecnologia e conhecimento técnico 
              para desenvolver soluções que fazem a diferença. Queremos ser referência em <strong>tecnologia em saúde</strong>, 
              sempre pensando primeiro no bem-estar dos pacientes.
            </p>
          </Col>

          <Col lg={6}>
            <div className="hero-image-container">
              <div className="hero-image">
                <img src={heroImage} alt="Sistema respiratório humano - Tecnologia em saúde respiratória da Bientech" className="img-fluid" />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;
